<template>
  <el-card>
    <section>
      <!--工具条-->
      <el-col :span="24" class="form-line">
        <el-form size="small" :inline="true" :model="filters">
          <el-form-item label="手机号（登录名）">
            <el-input v-model="filters.username" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名">
            <el-input v-model="filters.realName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="车牌号">
            <el-input v-model="filters.licensePlate" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker type="date"
                            placeholder="请选择开始日期"
                            value-format="yyyy-MM-dd"
                            v-model="filters.createTimeStart"
                            style="width: 180px;">
            </el-date-picker>-
            <el-date-picker type="date"
                            placeholder="请选择开始日期"
                            value-format="yyyy-MM-dd"
                            v-model="filters.createTimeEnd"
                            style="width: 180px;">
            </el-date-picker>
          </el-form-item>
          <div style="float: right">
            <el-form-item>
              <el-button-group>
                <el-button type="primary" icon="el-icon-search" @click="getOrderCountList()">查询</el-button>
                <el-button icon="el-icon-refresh-right" @click="resetFilter()">重置</el-button>
              </el-button-group>
            </el-form-item>
          </div>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table border size="medium" :data="orderCountList" highlight-current-row v-loading="listLoading" @selection-change="selsChange">
        <el-table-column type="index" min-width="60">
        </el-table-column>
        <el-table-column prop="username" label="手机号（登录名）" min-width="120">
        </el-table-column>
        <el-table-column prop="realName" label="真实姓名" min-width="120">
        </el-table-column>
        <el-table-column prop="licensePlate" label="车牌号" min-width="120">
        </el-table-column>
        <el-table-column prop="num" label="订单数" min-width="120">
        </el-table-column>

      </el-table>

      <!--工具条-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="padding: 15px 5px">
      </el-pagination>

    </section>
  </el-card>
</template>

<script>
/* eslint-disable */
import {base, doPost, download} from "@/api/api";

export default {
  name: 'DriverManagement',
  data () {
    return {
      uploadUrl: base + '/uploadFile/upload',
      fileList: [],
      filters: {
        username: '',
        realName: '',
        licensePlate: '',
        createTimeStart: '',
        createTimeEnd: ''
      },
      orderCountList: [],
      total: 0,
      listLoading: false,
      sels: [], // 列表选中列
      addFormVisible: false, // 新增界面是否显示
      addLoading: false,
      editFlag: false,
      messageTitle: '',
      messageSuc: '',
      value: '',
      user: {},
      sexList: [{label: '男',value: '男'},{label: '女',value: '女'}],
      zgzList: [{label: '出租汽车驾驶员从业资格',value: '出租汽车驾驶员从业资格'}],
    }
  },
  methods: {
    handleChanges1 (file, fileList) {
      console.log(111)
      if (fileList[0].status === 'success') {
        this.addForm.drivingLicenseImage = fileList[0].response.result
        console.log(this.addForm.drivingLicenseImage)
      }
    },
    handleChanges2 (file, fileList) {
      if (fileList[0].status === 'success') {
        this.addForm.qualificationLicenseImage = fileList[0].response.result
      }
    },
    // 限制上传格式
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt10M = file.size / 1024 / 1024 < 10
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片能是JPG格式或PNG格式!')
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return (isJPG || isPNG) && isLt10M
    },
    handleSizeChange (val) {
      this.filters.pageSize = val
      this.getOrderCountList()
    },
    handleCurrentChange (val) {
      this.filters.pageNum = val
      this.getOrderCountList()
    },
    resetFilter () {
      Object.assign(this.$data.filters, this.$options.data().filters)
    },
    // 获取消息列表
    getOrderCountList () {
      this.loading = true
      doPost('/order/countOrder', this.filters).then((res) => {
        console.log(res.result)
        this.total = res.result.total
        this.orderCountList = res.result.list
        this.loading = false
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    // 批量删除
    batchRemove: function () {
    },
    statusFormatter (row, column) {
      if (row.status === 1) {
        return '未读'
      } else if (row.status === 2) {
        return '已读'
      }
    }
  },
  mounted () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    this.getOrderCountList()
  }
}
</script>

<style scoped>
.driver-management {
  padding: 20px;
}

.object-contain {
  height: 160px;
  width: 100%;
  object-fit: contain;
  display: block;
  text-align: center;
}
.object-contain /deep/ .el-image__inner {
  object-fit: contain;
}
.object-contain /deep/ .el-image-viewer__close {
  color: #fff;
}
</style>
